import React from 'react';
import { storesContext } from '../stores';

function useStores(storeSelector) {
  const stores = React.useContext(storesContext);
  if (!stores) {
    throw new Error('[useStores] Cannot take stores from storesContext');
  }
  const store = storeSelector(stores);
  if (!store) {
    throw new Error('[useStores] storeSelector');
  }
  return store;
}

export default useStores;
